import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { useLocalStorage } from '@uidotdev/usehooks';
import Icons from 'components/Icons';
import { track } from 'common/analytics';
import classes from './TopBanner.module.css';

const TOP_BANNER_ID = 'br-valentines-2025';
const GAME_NAME = 'letroso';

const START_DATE = '2025-06-03';
const END_DATE = '2025-06-11';

function TopBanner({ onActionClick = () => {} }) {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useLocalStorage(
    `${GAME_NAME}-top-banner-dismissed`,
    '',
  );
  const { language } = useParams();

  const ignoreDismissed = false;
  const startDate = dayjs(START_DATE).startOf('day');
  const endDate = dayjs(END_DATE).endOf('day');

  const showBanner =
    language === 'pt' &&
    startDate.isBefore(dayjs()) &&
    endDate.isAfter(dayjs()) &&
    (ignoreDismissed || dismissed !== TOP_BANNER_ID);

  const handleActionClick = () => {
    track.topBannerAction(language, TOP_BANNER_ID);
    onActionClick();
  };

  const handleCloseClick = () => {
    track.topBannerDismiss(language, TOP_BANNER_ID);
    setDismissed(TOP_BANNER_ID);
  };

  return (
    <div
      className={`${classes.topBanner} ${classes.vertical} ${
        showBanner ? '' : classes.hidden
      }`}
    >
      <div className={classes.topBannerText}>{t('topBanner.text')}</div>
      <div className={`${classes.topBannerButtons} ${classes.vertical}`}>
        <a
          href={'https://www.instagram.com/p/DKcVkjqNaHW/'}
          target="_blank"
          rel="noreferrer"
          className="button small"
          onClick={handleActionClick}
        >
          <Icons.ExternalLink />
          {t('topBanner.action')}
        </a>
        <button
          type="button"
          className="button small subtle"
          onClick={handleCloseClick}
        >
          {t('topBanner.close')}
        </button>
      </div>
    </div>
  );
}

export default TopBanner;
